exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:991px){.map-page-contact[data-v-cc4e7d80]{width:100%!important}}", ""]);

// exports
